import { Grid } from '@mui/material';
import { useState } from 'react';

import { useSearchDayRangePlans } from '../hooks/useSearchDayRangePlans';
import { PlannerPlansCalendar as Calendar } from './PlannerPlansCalendar';

export interface DateRange {
  startDate?: string;
  endDate?: string;
}

export const PlannerPlansCalendar = () => {
  const [dateRange, setDateRange] = useState<DateRange>({ startDate: undefined, endDate: undefined });
  const {
    data: plans,
    isLoading,
    isInitialLoading,
  } = useSearchDayRangePlans({
    from: dateRange.startDate,
    to: dateRange.endDate,
  });
  return (
    <Grid container direction="column" wrap="nowrap" style={{ height: `100%` }}>
      <Calendar plans={plans ?? []} isLoading={isInitialLoading || isLoading} setDateRange={setDateRange} />
    </Grid>
  );
};
